"use client"

import { Skeleton } from "antd"
import { FC } from "react"

type SelectPlacementSkeletonProps = {
  size?: 'small' | 'default',
}

const SelectPlacementSkeleton: FC<SelectPlacementSkeletonProps> = ({ size = 'default' }) => {
  const isSmall = size === 'small'

  if (isSmall) {
    return (
      <div className="home__searching--field-control home__searching--field-control--stacked">
        <Skeleton paragraph={false} active styles={{ title: { height: '1.2rem', width: '6rem', margin: 0 } }} />
        <Skeleton paragraph={false} active styles={{ title: { height: '1.8rem', width: '100%', margin: '0.4rem 0 0' } }} />
      </div>
    )
  }

  return (
    <div className="home__searching--placement">
      <Skeleton paragraph={false} active styles={{ title: { height: '2.1rem', width: '7.7rem', margin: 0 } }} />
      <Skeleton paragraph={false} active styles={{ title: { height: '2.1rem', width: '100%', margin: '0.5rem 0 0' } }} />
    </div>
  )
}

export default SelectPlacementSkeleton
